exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "*{margin:0;padding:0}.container{max-width:1500px}.btn-primary,nav.navbar{background-color:#004a99}.btn-primary{border-color:#004a99}.btn-primary:focus,.btn-primary:hover{background-color:#0063cc;border-color:#0063cc}.table{font-size:14px}#app{font-family:Avenir,Helvetica,Arial,sans-serif;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}#app .container{margin-top:10px}ul{list-style-type:none}table th{background:#004a99!important;border-color:#0056b3!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-d8213b72","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 299
// module chunks = 7